import { Injectable } from '@angular/core';
import { QuestionnaireRequest } from 'src/API';
import { DerfsService } from 'src/app/questionnaires/derfs/derfs.service';
import { DryEyeMedicalHistoryFormGroup } from 'src/app/shared/consult-forms/dry-eye-forms/dry-eye-medical-history-form/dry-eye-medical-history-form.model';
import { splitMedicationFreeText } from '../medication/medication-free-text.util';
import { MedicalHistoryPopulator } from '../medical-history-source.model';

/**
 * Applies a DERFS / CDERFS questionnaire by normalising it through
 * `DerfsService.getDerfDataToCopy` and patching the result onto the form.
 */
@Injectable({ providedIn: 'root' })
export class DerfsPopulator implements MedicalHistoryPopulator {
  constructor(private derfsService: DerfsService) {}

  populate(formGroup: DryEyeMedicalHistoryFormGroup, questionnaire: QuestionnaireRequest): void {
    let derfsData: any;
    try {
      derfsData = this.derfsService.getDerfDataToCopy(questionnaire);
    } catch {
      return;
    }
    if (!derfsData) {
      return;
    }
    const currentFreeText = formGroup.controls.patientEnteredMedicationsFreeText.value;
    formGroup.patchValue({
      ...derfsData,
      // Merge rather than overwrite so meds already staged by earlier sources
      // survive (including a string-valued free text from the legacy intake path);
      // the final MedicationReconciler dedupes into `medications`.
      patientEnteredMedicationsFreeText: [
        ...splitMedicationFreeText(currentFreeText),
        ...splitMedicationFreeText(derfsData.patientEnteredMedicationsFreeText)
      ]
    });
  }
}
